import { NgModule } from '@angular/core';
import { AppConfigComponent } from './app.config.component';

@NgModule({
    imports: [],
    declarations: [AppConfigComponent],
    exports: [AppConfigComponent],
})
export class AppConfigModule {}
